import type { TextFieldProps as BaseTextFieldProps } from "@alch/ui";
import { TextField as BaseTextField } from "@alch/ui";
import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { useController } from "react-hook-form";

type TextFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = BaseTextFieldProps & {
  control: Control<TFieldValues>;
  name: TName;
  formatValue?: (value: TFieldValues[TName] | string) => string;
};

const TextField = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  control,
  name,
  formatValue,
  ...props
}: TextFieldProps<TFieldValues, TName>) => {
  const {
    field: { onChange, ...field },
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  return (
    <BaseTextField
      {...props}
      {...field}
      onChange={(e) =>
        formatValue ? onChange(formatValue(e.target.value)) : onChange(e)
      }
      value={formatValue ? formatValue(field.value) : field.value}
      errorMessage={error?.message}
    />
  );
};

export default TextField;
